import AXIOS from './axiosClient';

class AvailSearchService {
  searchMultiAvail(availSearchRequest) {
    return AXIOS.post('/searchMultiAvail', availSearchRequest);
  }

  searchMultiAvailPage(availSearchRequest, page) {
    console.log("searchMultiAvailPage: ", {searchRequest: availSearchRequest, page: page});
    return AXIOS.post('/searchMultiAvailPaged?sort=' + page.sortField + ',' + (page.sortOrder === 1 ? 'ASC' : 'DESC') + '&page=' + page.page + '&size=' + page.rows, availSearchRequest);
  }

  loadLicences(availSearchRequest) {
    return AXIOS.post('/getLicences', availSearchRequest);
  }

  loadSingleAvail(availSearchRequest) {
    return AXIOS.post('/getSingleAvail', availSearchRequest);
  }

  getDetails(availSearchRequest) {
    return AXIOS.post('/getDetails', availSearchRequest);
  }
}

export default new AvailSearchService();